import { atom } from 'jotai';

export type RenderingImage = {
  id: string;
  originalImage: string;
  originalImageId?: string;
  renderedImage?: string;
  renderedImageId?: string;
  magicEditMode?: 'free-edit' | 'remove';
  renderingType?: 'ai-rendering';
  watermarkApplied?: boolean;
  fileType: string;
  file: File | null;
};

export const renderingsUploadedImagesAtom = atom<RenderingImage[]>([]);

export const renderingsSelectedImageAtom = atom<RenderingImage | undefined>(undefined);

export const renderingsSelectedPreviewImageAtom = atom<RenderingImage | undefined>(undefined);

export const renderingsCurrentImageAtom = atom((get) => {
  return get(renderingsSelectedPreviewImageAtom) ?? get(renderingsSelectedImageAtom);
});
